export default __webpack_public_path__ + "static/media/Animals-20.e9c008f6.png";